export const MODE = import.meta.env?.MODE;
export const GIT_SHA = import.meta.env?.VITE_GIT_SHA as string;
export const GIT_REF = import.meta.env?.VITE_GIT_REF as string;

// TODO: separate env file for test
export type Language = "en-GB" | "de-DE";
export const DEFAULT_LANGUAGE: Language = "en-GB";

export const IS_NODE_ENV_PRODUCTION = process.env.NODE_ENV === "production";
export const IS_NODE_ENV_TEST = process.env.NODE_ENV === "test";
export const IS_NODE_ENV_DEVELOPMENT = process.env.NODE_ENV === "development";
